"use client";

import Image from "next/image";
import { useEffect, useMemo, useState } from "react";
import type { GalleryItem } from "@/lib/content-types";
import { ImageZoom } from "@/components/image-zoom";

export function GalleryBrowser() {
  const [filter, setFilter] = useState("Tout");
  const [liveGallery, setLiveGallery] = useState<GalleryItem[]>([]);
  useEffect(() => { void fetch("/api/gallery", { cache: "no-store" }).then((response) => response.ok ? response.json() : null).then((data) => { if (Array.isArray(data?.gallery) && data.gallery.length) setLiveGallery(data.gallery); }).catch(() => undefined); }, []);
  const filters = useMemo(() => ["Tout", ...Array.from(new Set(liveGallery.map((item) => item.category)))], [liveGallery]);
  const items = useMemo(() => filter === "Tout" ? liveGallery : liveGallery.filter((item) => item.category === filter), [filter, liveGallery]);

  return (
    <section className="section gallery-page-section">
      <div className="container">
        <div className="gallery-filters" aria-label="Filtrer les réalisations">
          {filters.map((item) => <button type="button" className={filter === item ? "active" : ""} onClick={() => setFilter(item)} key={item}>{item}</button>)}
        </div>
        <div className="gallery-page-grid">
          {items.map((item) => (
            <figure className="gallery-item" key={`${item.category}-${item.title}`}>
              <ImageZoom src={item.image} alt={item.title} className="gallery-image-zoom"><Image src={item.image} alt="" fill sizes="(max-width: 700px) 100vw, (max-width: 1100px) 50vw, 33vw" /></ImageZoom>
              <figcaption><span>{item.category}</span><strong>{item.title}</strong></figcaption>
            </figure>
          ))}
        </div>
        <p className="gallery-help">Une sélection des réalisations est également publiée régulièrement sur Instagram.</p>
      </div>
    </section>
  );
}
